import Vue from 'vue';
import VueResource from 'vue-resource';
import VueSweetalert2 from 'vue-sweetalert2';
import App from './App';
import router from './router';
import jQuery from 'jquery';
import Plugins from './plugins';
import Filters from './filters';
import store from './store';
import Components from './components';


window.$ = jQuery;
window.jQuery = jQuery;

Vue.config.productionTip = false;

Vue.use(VueResource);
Vue.use(VueSweetalert2);

Plugins.install(Vue);
Filters.install(Vue);
Components.initializeComponents(Vue);

var app = new Vue({
    el: '#app',
    router,
    store,
    // http: {
    //   root: 'http://localhost:3000/'
    // },
    components: { App },
    template: '<App/>'
});

window.Vue = Vue;


// WEBPACK FOOTER //
// ./src/main.js